import { sendSlackMessage, SLACK_CHANNELS } from "./";

export const sendSlackError = (
  message: string,
  fields: Array<Record<string, string>> = [],
): null => {
  if (import.meta.env.VITE_NODE_ENV === "production") {
    const errorKey = "lastErrors";
    let lastErrors: string[] = [];
    let duplicateError = false;
    const storageLastErrors = JSON.parse(localStorage.getItem(errorKey)) as
      string[] | null;
    if (storageLastErrors?.length) {
      lastErrors = lastErrors.concat(storageLastErrors);
      if (lastErrors.find((error) => error === message)) {
        duplicateError = true;
      } else {
        lastErrors.push(message);
        localStorage.setItem(errorKey, JSON.stringify(lastErrors));
      }
    } else {
      lastErrors.push(message);
      localStorage.setItem(errorKey, JSON.stringify(lastErrors));
    }

    if (!duplicateError) {
      const slackErrorData = {
        channel: SLACK_CHANNELS.FRONTEND_ERRORS,
        type: "error",
        heading: window.location.href,
        detail: message.split("\n").join("\\n"),
        fields: fields,
        // fields: [
        //   {
        //     title: "User ID",
        //     value: userId
        //   },
        //   {
        //     title: "User Name",
        //     value: userName
        //   },
        //   {
        //     title: "User Email",
        //     value: userEmail
        //   },
        //   {
        //     title: "User Team",
        //     value: teamName
        //   }
        // ]
      };
      sendSlackMessage(slackErrorData);
    }
  }
  return null;
};
